var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "c-form" }, [
      _c(
        "div",
        {
          staticClass: "c-form__fieldset",
          class: { "c-form__group--error": _vm.$v.newGroup.$error }
        },
        [
          _c("div", { staticClass: "row c-form__group" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-9 col-md-9 col-lg-10" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.newGroup,
                      expression: "newGroup",
                      modifiers: { trim: true }
                    }
                  ],
                  staticClass: "c-form__field",
                  attrs: { type: "text", id: "group_name" },
                  domProps: { value: _vm.newGroup },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newGroup = $event.target.value.trim()
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            !_vm.$v.newGroup.required
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-6 offset-sm-6 col-md-6 offset-md-2 c-form__error"
                  },
                  [
                    _c("p", { staticClass: "label--error" }, [
                      _vm._v("Group name is required")
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.$v.newGroup.maxLength
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-6 offset-sm-6 col-md-6 offset-md-2 c-form__error"
                  },
                  [
                    _c("p", { staticClass: "label--error" }, [
                      _vm._v(
                        "The Group name can not have more than 30 characters."
                      )
                    ])
                  ]
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c-form__fieldset" }, [
        _c("div", { staticClass: "row c-form__group" }, [
          _c(
            "div",
            {
              staticClass:
                "col-xs-12 col-sm-6 col-md-6 offset-md-3 offset-lg-2 col-lg-5 col-xl-4"
            },
            [
              _c(
                "button",
                {
                  staticClass: "c-btn c-btn--success",
                  on: {
                    click: function($event) {
                      return _vm.addDomainGroup()
                    }
                  }
                },
                [
                  _c("fa", { attrs: { icon: ["far", "plus-square"] } }),
                  _vm._v(" Add group\n                    ")
                ],
                1
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("h5", [_vm._v("Group List")]),
    _vm._v(" "),
    _vm.groups.length
      ? _c(
          "div",
          { staticClass: "c-table" },
          [
            _vm._l(_vm.groups, function(group) {
              return [
                _c(
                  "div",
                  { key: group.id, staticClass: "c-table__row" },
                  [
                    _vm.editingGroupId !== group.id
                      ? [
                          _c("div", { staticClass: "c-table__data name" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(group.group_name) +
                                "\n                    "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "c-table__data c-table__action" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "c-btn c-btn--info",
                                  on: {
                                    click: function($event) {
                                      return _vm.startEdit(
                                        group.id,
                                        group.group_name
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            Edit\n                        "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "c-table__data c-table__action" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "c-btn c-btn--table c-btn--remove",
                                  attrs: {
                                    title: "Delete Group " + group.group_name
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeGroup(
                                        group.id,
                                        group.group_name
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "ccs-table__icon icon-delete-ccs icon-ccs"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      : [
                          _c("div", { staticClass: "c-table__data input" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.editingGroupName,
                                  expression: "editingGroupName"
                                }
                              ],
                              staticClass: "c-form__field",
                              attrs: { type: "text" },
                              domProps: { value: _vm.editingGroupName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.editingGroupName = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "c-table__data c-table__action" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "c-btn c-btn--success",
                                  on: { click: _vm.saveEdit }
                                },
                                [_vm._v("Save")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "c-table__data c-table__action" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "c-btn c-btn--table c-btn--remove",
                                  attrs: { title: "Cancel Changes" },
                                  on: { click: _vm.cancelEdit }
                                },
                                [_c("fa", { attrs: { icon: ["fas", "ban"] } })],
                                1
                              )
                            ]
                          )
                        ]
                  ],
                  2
                )
              ]
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-12 col-sm-3 col-md-3 col-lg-2" }, [
      _c(
        "label",
        { staticClass: "c-form__label", attrs: { for: "group_name" } },
        [_vm._v("Group name")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }